import { render, staticRenderFns } from "./AberturaProcesso.vue?vue&type=template&id=60fc2c61&"
import script from "./AberturaProcesso.vue?vue&type=script&lang=js&"
export * from "./AberturaProcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AberturaProcesso.vue"
export default component.exports